import get from 'lodash/get';
import { AxiosError } from 'axios';

interface ErroneousHttpResponse {
  httpStatus?: number;
  errorMessages?: string[];
}

const enhanceError = (error: AxiosError & ErroneousHttpResponse, { httpStatus, errorMessages }: ErroneousHttpResponse) => {
  error.httpStatus = httpStatus;
  error.errorMessages = errorMessages;
  return error;
};

export const throwWrappedAxiosError = (axiosError: AxiosError) => {
  const httpStatus = get(axiosError, 'response.status');
  const errorMessages = get(axiosError, 'response.data.errors', []);
  const ui = {
    httpStatus,
    errorMessages,
  };
  throw enhanceError(axiosError, ui);
};
